export default __webpack_public_path__ + "static/media/valor2.d3f643e3.png";